const ALERT = 'ALERT'

export const alert = config => async dispatch => {
  if (config.show) {
    dispatch({
      type: ALERT,
      show: false,
    })
  }

  dispatch({
    type: ALERT,
    ...config,
  })
}

const initialState = {
  show: false,
  kind: 'success',
  title: 'Success!',
  message: 'You are successful!',
  selfDestruct: false,
  largeAlert: false,
}

export const reducer = (state = initialState, action) => {
  const { type, ...rest } = action
  if (type !== ALERT) return state
  return { ...state, ...rest }
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/lib/alert.js